var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.386 9.11818L10.8813 1.61349C10.6471 1.38068 10.3303 1.25 10 1.25C9.66981 1.25 9.35299 1.38068 9.11879 1.61349L1.6141 9.11818C1.38129 9.35238 1.25061 9.6692 1.25061 9.99943C1.25061 10.3297 1.38129 10.6465 1.6141 10.8807L9.11879 18.3854C9.35299 18.6182 9.66981 18.7489 10 18.7489C10.3303 18.7489 10.6471 18.6182 10.8813 18.3854L18.386 10.8807C18.6188 10.6465 18.7495 10.3297 18.7495 9.99943C18.7495 9.6692 18.6188 9.35238 18.386 9.11818ZM10 2.49943L14.375 6.87443H12.5C12.4179 6.87436 12.3366 6.89048 12.2608 6.92184C12.1849 6.95321 12.1159 6.99922 12.0578 7.05724L10 9.11505L7.94223 7.05724C7.88414 6.99922 7.81519 6.95321 7.73932 6.92184C7.66345 6.89048 7.58214 6.87436 7.50004 6.87443H5.62504L10 2.49943ZM4.37504 8.12443H7.24066L9.11566 9.99943L7.24066 11.8744H4.37504L2.50004 9.99943L4.37504 8.12443ZM10 17.4994L5.62504 13.1244H7.50004C7.58214 13.1245 7.66345 13.1084 7.73932 13.077C7.81519 13.0456 7.88414 12.9996 7.94223 12.9416L10 10.883L12.0578 12.9416C12.1159 12.9996 12.1849 13.0456 12.2608 13.077C12.3366 13.1084 12.4179 13.1245 12.5 13.1244H14.375L10 17.4994ZM15.625 11.8744H12.7594L10.8844 9.99943L12.7594 8.12443H15.625L17.5 9.99943L15.625 11.8744Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixLogo);
export default __webpack_public_path__ + "static/media/pixLogo.0bfaf01feb634ab30455583a6b3529dc.svg";
export { ForwardRef as ReactComponent };